import CustomDialog from '../../../../../Common/CustomDialog'
import {StyledActionBox} from '../../../../../Common/Styles'
import {StyledActionAddButton, StyledActionResetButton, StyledInterestTagTitleContainer} from '../../../Styles'
import {StyledPopupDialog} from '../ChatViewStyles'
import theme from '../../../../../../themes/index'
import PropTypes from 'prop-types'

const PopupDialogContent = ({dialogContent}) => {
  return <StyledPopupDialog>{dialogContent}</StyledPopupDialog>
}

const ConfirmDialog = ({open, title, content, handleClose, handleConfirm}) => {
  return (
    <CustomDialog
      open={open}
      showDivider={false}
      maxWidth="xs"
      timelineDialog={true}
      showCloseBtn={false}
      isZIndexReqired={true}
      title={
        <StyledInterestTagTitleContainer sx={{fontSize: theme.typography.heading.fontSize.l}}>
          {title}
        </StyledInterestTagTitleContainer>
      }
      handleClose={handleClose}
      content={<PopupDialogContent dialogContent={content} />}
      actions={
        <StyledActionBox>
          <StyledActionResetButton onClick={handleClose}>Cancel</StyledActionResetButton>
          <StyledActionAddButton onClick={handleConfirm}>Confirm</StyledActionAddButton>
        </StyledActionBox>
      }
    />
  )
}

PopupDialogContent.propTypes = {
  dialogContent: PropTypes.string.isRequired
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired
}

export default ConfirmDialog
